export default {
  header: (isCategoryPage: boolean) => ({
    margin: isCategoryPage ? ['64px 40px 40px 40px', '64px 40px 40px 40px', '80px 64px 40px 64px', '80px 64px 40px 64px', '116px 195px 48px 195px', '88px 195px 48px 195px'] : ['48px 0', '48px 0', '64px 0', '64px 0', '116px 0']
  })
};